import logallComponent from './log.all.component';

let logallModule = angular.module('logall', [
  ])

  .component('logall', logallComponent)

  .name;

export default logallModule;


// WEBPACK FOOTER //
// ./client/app/components/log/all/index.js